/* unplugin-vue-components disabled */import { render } from "./CollectBase.vue?vue&type=template&id=32ce2024"
import script from "./CollectBase.vue?vue&type=script&lang=js"
export * from "./CollectBase.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__